import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  styles = ['green-snackbar', 'yellow-snackbar', 'red-snackbar', 'orange-snackbar'];
  duration = 3000;
  message: string;

  constructor(
    private _snackBar: MatSnackBar,
    private translate: TranslateService
  ) {
  }

  info(code: string) {
    this.translate.get(code).subscribe(message => this.message = message);
    this._snackBar.open(this.message, '', {
      duration: this.duration,
      panelClass: [this.styles[0]]
    });
  }

  warn(code: string) {
    this.translate.get(code).subscribe(message => this.message = message);
    this._snackBar.open(this.message, '', {
      duration: this.duration,
      panelClass: [this.styles[1]]
    });
  }

  orange(code: string) {
    this.translate.get(code).subscribe(message => this.message = message);
    this._snackBar.open(this.message, '', {
      duration: 5000,
      panelClass: [this.styles[3]]
    });
  }

  error(message: string) {
    this._snackBar.open(message, '', {
      duration: this.duration,
      panelClass: [this.styles[2]]
    });
  }

  errorCode(code: string) {
    this.translate.get(code).subscribe(message => this.message = message);
    this._snackBar.open(this.message, '', {
      duration: this.duration,
      panelClass: [this.styles[2]]
    });
  }
}
